import React from 'react';
import { useTranslation } from 'react-i18next';

import { Label } from '../../../../styles/sharedUIElemStyles';
import { Input } from './FormInput.style';
import { debounce } from 'debounce';

export interface Value {
  data: string;
  dataIndex: string;
}
export interface Props {
  index: string;
  updateFormData: (index: any) => void;
  value: Value;
  defaultValue: Value;
  readOnly: boolean;
  template: any;
}
/**
 * Komponent do wpisywania krótkiej wartości tekstowej
 *
 */
export const FormInput: React.FunctionComponent<Props> = (props: Props): React.ReactElement => {
  const { t } = useTranslation();

  const updateForm = debounce((value: string): void => {
    const updatedData = {
      ...props.value,
      data: value,
    };
    props.updateFormData(updatedData);
  }, 200);
  return (
    <>
      {props.readOnly ? (
        <p>{props.value.data && props.value.data.length ? props.value.data : t('NO_DATA')}</p>
      ) : (
        <>
          <p>
            {!props.readOnly ? (
              <Label>
                {t('BEFORE_CHANGE')}
                :&nbsp;
              </Label>
            ) : null}
            {props.defaultValue.data && props.defaultValue.data.length ? props.defaultValue.data : t('NO_DATA')}
          </p>
          <Input
            allowClear
            defaultValue={props.defaultValue.data}
            onChange={({ currentTarget: { value } }: React.ChangeEvent<HTMLInputElement>): void => updateForm(value)}
            required={true}
          />
        </>
      )}
    </>
  );
};
export default FormInput;
